import axios from 'axios'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'

export const useProductCatalogue = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [catalog, setCatalog] = useState(false)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { getNewProductCatalogues, addNewProductCatalogue, editNewProductCatalogue, deleteNewProductCatalogue } = useContext(FeatureContext)

  //PRODUCTCATALOGUES
  const getAllProductCatalogues = (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_PRODUCTCATALOGUE(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPaginate(data.paginate)
        getNewProductCatalogues(data.data ? data.data : [], data.totalPage)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const addProductCatalogue = async (dto) => {
    //console.log('DTO PC', dto)
    setLoading(true)
    axios
      .post(API.ADD_PRODUCTCATALOGUE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Product Catalogue Added Successfully', success)
        // addNewProductCatalogue(data.productCatalouge)
        history.push(ROUTES.PRODUCT_CATALOGUE)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || err.response.data.errors[0].msg, error)
        }
      })
  }

  const editProductCatalogue = async (dto) => {
    setLoading(true)
    axios
      .put(API.UPDATE_PRODUCTCATALOGUE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Product Catalog Updated Successfully', success)
        history.push(ROUTES.PRODUCT_CATALOGUE)
        getAllProductCatalogues()
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        // if (err.response) {
        //   //console.log(err.response)
        //   return toastMessage(err.response.data.error, error)
        // }
      })
  }
  const getProductCatalogue = async (dto) => {
    setLoading(true)
    axios
      .post(API.GET_PRODUCTCATALOGUE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        // toastMessage('Product Updated Successfully', success)
        // editNewProductCatalogue(data.productCatalouge)
        setCatalog(data.data)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const deleteProductCatalouge = async (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_PRODUCTCATALOGUE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('ProductCatalouge Deleted Successfully', success)
        //console.log(dto)
        deleteNewProductCatalogue(dto.productCatalougeId)
        setSelected([])
        // setLoading(true)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const deleteManyProductCatalouge = async (dto, setSelected) => {
    setLoading(true)
    //console.log('DTO : ', dto)
    axios
      .post(API.DELETE_MANY_PRODUCTCATALOUGE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.productCatalougeId.length} ProductCatalouge Deleted Successfully`, success)

        dto.productCatalougeId.map((item) => deleteNewProductCatalogue(item))
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        data.data.map((item) => addNewProductCatalogue(item))
        toastMessage(`${data.data.length} Data Inserted Successfully`, success)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  return {
    getAllProductCatalogues,
    addProductCatalogue,
    editProductCatalogue,
    deleteProductCatalouge,
    BulkUpload,
    deleteManyProductCatalouge,
    getProductCatalogue,
    catalog,
    loading,
    paginate,
  }
}
